import { DatePipe } from '@angular/common';
import {
    Component, DoCheck, EventEmitter,
    Input, OnDestroy,
    OnInit, Output, ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, timer } from 'rxjs';
import { PhoneInputComponent } from 'src/app/module/phone-input/phone-input.component';
import { CaptchaComponent } from '../captcha/captcha.component';


@Component({
    selector: 'app-enter-sms-code',
    templateUrl: './enterSMSCode.component.html',
    styleUrls: ['./enterSMSCode.component.scss'],
})
export class EnterSMSCodeComponent implements OnInit, OnDestroy, DoCheck {

    private _expiredConfirmCodeDate: Date;
    private _confirmCodeLifeTimeText: string;
    private _confirmCodeExpiredText: string;
    private _catchaValidationErrorTranslate: string;

    constructor(
        private _translateService: TranslateService,
        private datepipe: DatePipe) {
    }

    public errorText: string;
    public confirmCodeValue: string;
    public confirmCodeAllowReSend: boolean;
    public confirmCodeLifeTimeText: string;
    public confirmCodeLifeTimeSubscription: Subscription;
    public submitProcessing: boolean;
    public reSendProcessing: boolean;
    public showCaptcha: boolean;

    public captchaCode: string;

    @Input() phoneValueWithRegion: string;
    @Output() phoneValueWithRegionChange = new EventEmitter<string>();
    @Input() submitButtonText: string;
    @Output() resendSMSCode = new EventEmitter();
    @Output() submited = new EventEmitter();

    @ViewChild('captchaComponent') captchaComponent: CaptchaComponent;

    ngOnInit(): void {
        this._initTranslations();
    }

    ngDoCheck(): void {
    }

    ngOnDestroy(): void {
        this.confirmCodeLifeTimeSubscription?.unsubscribe();
    }

    private _initTranslations() {
        this._translateService.get(
                [
                    'Components.EnterSMSCode.ConfirmCodeLifeTimeText',
                    'Components.EnterSMSCode.ConfirmCodeExpiredText',
                    'Common.CaptchaValidationError',
                ])
            .subscribe(
                result => {
                    this._confirmCodeLifeTimeText = result['Components.EnterSMSCode.ConfirmCodeLifeTimeText'];
                    this._confirmCodeExpiredText = result['Components.EnterSMSCode.ConfirmCodeExpiredText'];
                    this._catchaValidationErrorTranslate = result['Common.CaptchaValidationError'];
                });
    }


    public reSendCodeButtonClick(event: Event): void {
        this.reSendProcessing = true;
        this.submitProcessing = false;
        this.resendSMSCode.emit();
    }

    public submitButtonClick(event: Event): void {
        this.errorText = null;
        this.submitProcessing = true;
        this.submited.emit();
    }

    /**
     * Запускает таймер обратного отсчета для повторной отправки кода подтверждения
     */
    public startLifeTimeTimer() {
        this._expiredConfirmCodeDate = new Date(new Date().getTime() + (1000 * 60 * 5));
        this.confirmCodeAllowReSend = false;
        this.confirmCodeLifeTimeSubscription?.unsubscribe();

        this.confirmCodeLifeTimeSubscription = timer(0, 1000)
            .subscribe(() => {
                const lifeTimeDate: Date = new Date(this._expiredConfirmCodeDate.getTime() - new Date().getTime());
                if (lifeTimeDate.getTime() <= 0) {
                    this.confirmCodeLifeTimeText = this._confirmCodeExpiredText;
                    this.confirmCodeAllowReSend = true;
                    this.reSendProcessing = false;
                    this.submitProcessing = true;
                    this.confirmCodeLifeTimeSubscription?.unsubscribe();

                    this.showCaptcha = true;
                } else {
                    this.confirmCodeLifeTimeText =
                        this._confirmCodeLifeTimeText.replace('{0}', this.datepipe.transform(lifeTimeDate, 'mm:ss'));
                }
            });

        this.showCaptcha = false;
        this.errorText = null;
        this.confirmCodeValue = null;
        this.captchaCode = null;
    }

    public clear() {
        this.errorText = null;
        this.confirmCodeValue = null;
        this.confirmCodeAllowReSend = false;
        this.captchaCode = null;
        this.confirmCodeLifeTimeSubscription?.unsubscribe();
    }

    public clearWithoutPhone() {

        this.phoneValueWithRegion = null;
    }

    public captchaError(): void {
        this.reSendProcessing = false;
        this.submitProcessing = true;
        this.errorText = this._catchaValidationErrorTranslate;
        if (this.captchaComponent) {
            this.captchaCode = null;
            this.captchaComponent.refreshCaptcha();
        }
    }
}
